import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';

import { HotelValidationResponse } from '@booking/entities/hotel-validation.response';
import {
  TypographyFontSize, TypographyColor, TypographyFontFamily
} from '@design-system/components/atoms/typography/entities/typography.types';

@Component({
  selector: 'app-hotels-policies',
  templateUrl: './hotels-policies.component.html',
  styleUrls: [
    '../policies-detail/policies-detail.component.sass'
  ],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelsPoliciesComponent {

  @Input() hotelValidation: HotelValidationResponse;
  @Input() titleClass: string;
  @Input() isUserHistory = false;

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;
  public readonly fontFamily = TypographyFontFamily;

  constructor() { }

  get hasHotelPolicies(): boolean {
    return !isEmpty(this.hotelValidation) && this.hasCancelPolicies;
  }

  get hasCancelPolicies(): boolean {
    return !!this.hotelValidation?.CancellationPolicies?.length;
  }

}
